module.exports = __webpack_public_path__ + "assets/img/info2.e7359e13.svg";